customAuthPlanSkus